import { __extends } from "tslib";
import { AbstractionBase } from '@awayjs/core';
/**
 * @class away.partition.EntityNode
 */
var EntityNode = /** @class */ (function (_super) {
    __extends(EntityNode, _super);
    /**
     *
     * @returns {number}
     */
    function EntityNode(entity, partition) {
        return _super.call(this, entity, partition) || this;
    }
    Object.defineProperty(EntityNode.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntityNode.prototype, "pool", {
        get: function () {
            return this._pool;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntityNode.prototype, "entity", {
        get: function () {
            return this._asset;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntityNode.prototype, "partition", {
        get: function () {
            return this._pool;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntityNode.prototype, "boundsVisible", {
        get: function () {
            if (this._boundsVisible != this._asset.boundsVisible) {
                this._boundsVisible = this._asset.boundsVisible;
                if (this._boundsVisible) {
                    this._boundsPrimitiveDirty = true;
                }
                else if (this._boundsPrimitive) {
                    this._boundsPrimitive.setParent(null);
                    this._boundsPrimitive = null;
                }
            }
            return this._boundsVisible;
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     * @returns {boolean}
     */
    EntityNode.prototype.isCastingShadow = function () {
        return this._asset.castsShadows;
    };
    EntityNode.prototype.onClear = function (event) {
        this._pool.clearEntity(this);
        _super.prototype.onClear.call(this, event);
        this.clear();
    };
    EntityNode.prototype.onInvalidate = function (event) {
        _super.prototype.onInvalidate.call(this, event);
        this.invalidate();
    };
    /**
     *
     * @param planes
     * @param numPlanes
     * @returns {boolean}
     */
    /**
     *
     * @param planes
     * @param numPlanes
     * @returns {boolean}
     */
    EntityNode.prototype.isInFrustum = function (rootEntity, planes, numPlanes, pickGroup) {
        if (this.isInvisible())
            return false;
        return true;
        return this._asset.getAbstraction(pickGroup)._isInFrustumInternal(rootEntity, planes, numPlanes);
    };
    EntityNode.prototype.isInvisible = function () {
        return this._parent.isInvisible();
    };
    EntityNode.prototype.getMaskId = function () {
        return this._parent.getMaskId();
    };
    EntityNode.prototype.getBoundsPrimitive = function (pickGroup) {
        if (this._boundsPrimitiveDirty) {
            this._boundsPrimitiveDirty = false;
            this._boundsPrimitive = this.entity
                .getBoundsPrimitive(pickGroup.getBoundsPicker(this.partition))
                .getAbstraction(this.partition);
            this._boundsPrimitive.setParent(this._parent);
        }
        return this._boundsPrimitive;
    };
    /**
     * @inheritDoc
     */
    EntityNode.prototype.isIntersectingRay = function (rootEntity, globalRayPosition, globalRayDirection, pickGroup) {
        // if (!(<IPartitionEntity> this._asset).partition)
        // 	return false;
        // var box:Box = pickGroup.getBoundsPicker((<IPartitionEntity> this._asset).partition).getBoxBounds(null, false, true);
        // if (box == null)
        // 	return false;
        // if (box.rayIntersection((<IPartitionEntity> this._asset).transform.inverseConcatenatedMatrix3D.transformVector(globalRayPosition), (<IPartitionEntity> this._asset).transform.inverseConcatenatedMatrix3D.deltaTransformVector(globalRayDirection)) < 0)
        // 	return false;
        return this.getAbstraction(pickGroup)._isIntersectingRayInternal(rootEntity, globalRayPosition, globalRayDirection);
    };
    /**
     *
     * @returns {boolean}
     */
    EntityNode.prototype.isRenderable = function () {
        var p = this.parent;
        var tree = p.getIsCacheAsBitmap();
        var self = p.getIsCacheSource();
        // we can render only when self cached (because handle a cache texture) or when both is not cached
        var rendered = self || (!tree && !self);
        return p.getColorTransform()._isRenderable() && rendered;
    };
    /**
     * @inheritDoc
     */
    EntityNode.prototype.acceptTraverser = function (traverser) {
        if (traverser.enterNode(this))
            traverser.applyEntity(this);
    };
    EntityNode.prototype.setParent = function (parent) {
        if (!parent)
            this.onClear(null);
        this._parent = parent;
    };
    return EntityNode;
}(AbstractionBase));
export { EntityNode };
